import { Link, useLocation } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex flex-1 items-center justify-center px-4 py-20 md:px-6">
        <div className="w-full max-w-xl text-center animate-fade-up">
          <p className="font-heading text-[6rem] font-black leading-none text-primary-200 md:text-[9rem]">404</p>
          <h1 className="-mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            页面走丢了
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            没有找到你需要的内容，也许链接已经失效或输入有误。你可以返回首页，或从下方入口继续浏览伦理剧作品。
          </p>
          <p className="mt-3 break-all rounded-md bg-background-100 px-4 py-2 text-xs text-foreground-500">
            请求路径：{location.pathname}
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-home-4-line text-lg" />
              返回首页
            </Link>
            <Link
              to="/category/ethical-drama"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              浏览伦理剧
            </Link>
            <Link
              to="/special"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
            >
              查看专题
            </Link>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}